import {useSettingsPreviewMode} from '@common/admin/settings/preview/use-settings-preview-mode';
import {getBootstrapData} from '@ui/bootstrap-data/bootstrap-data-store';
import {useSettings} from '@ui/settings/use-settings';
import lazyLoader from '@ui/utils/loaders/lazy-loader';
import {useEffect} from 'react';
import {useLocation} from 'react-router';

const scriptTagId = 'hc-auto-livechat-loader';

export function HcLivechatWidgetLoader() {
  const {base_url, hc} = useSettings();
  const {isInsideSettingsPreview} = useSettingsPreviewMode();
  const {pathname} = useLocation();

  const livechatEnabled = hc?.showLivechat;
  const livechatUser = getBootstrapData().livechatWidgetUser;
  const shouldLoadLivechat =
    livechatEnabled &&
    (!hc?.livechatAuthOnly || (hc?.livechatAuthOnly && livechatUser)) &&
    !isInsideSettingsPreview &&
    (pathname.startsWith('/hc') || pathname === '/');

  useEffect(() => {
    const url = `${base_url}/livechat-loader.js`;

    // don't unload livechat if it's added via <script> tag and livechat in help center is disabled
    if (!livechatEnabled) {
      return;
    }

    if (shouldLoadLivechat) {
      (window as any).BeChatSettings = {
        user: livechatUser,
      };
      if (document.querySelector(`#${scriptTagId}`)) {
        if (livechatUser && (window as any).BeChat?.setUserData) {
          (window as any).BeChat.setUserData(livechatUser);
        }
      } else {
        lazyLoader.loadAsset(url, {type: 'js', id: scriptTagId});
      }
    } else if ((window as any).BeChat) {
      (window as any).BeChat?.destroy();
      lazyLoader.removeLoadedAsset(url);
      document.querySelector(`#${scriptTagId}`)?.remove();
      delete (window as any).BeChatSettings;
    }
  }, [shouldLoadLivechat, livechatUser, livechatEnabled, base_url]);

  return null;
}
